import { ContextGLBlendFactor } from '../base/ContextGLBlendFactor';
var FilterBase = /** @class */ (function () {
    function FilterBase() {
        this._tasks = [];
        this._temp = [];
        this._activeTaskIndex = -1;
        this.imageScale = 1;
    }
    Object.defineProperty(FilterBase.prototype, "isValid", {
        get: function () {
            for (var _i = 0, _a = this._tasks; _i < _a.length; _i++) {
                var t = _a[_i];
                if (!t.isValid) {
                    return false;
                }
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterBase.prototype, "requireBlend", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterBase.prototype, "blendDst", {
        get: function () {
            return ContextGLBlendFactor.ZERO;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterBase.prototype, "blendSrc", {
        get: function () {
            return ContextGLBlendFactor.ONE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterBase.prototype, "requireDepthRender", {
        get: function () {
            return this._requireDepthRender;
        },
        enumerable: false,
        configurable: true
    });
    FilterBase.prototype.addTask = function (filter) {
        this._tasks.push(filter);
        if (this._requireDepthRender == null)
            this._requireDepthRender = filter.requireDepthRender;
    };
    /**
     * Query next task while this possible, real task-passes can be greater that task count (multipassed blur)
     */
    FilterBase.prototype.nextTask = function () {
        return this._activeTaskIndex < this._tasks.length
            ? this._tasks[++this._activeTaskIndex]
            : null;
    };
    FilterBase.prototype.hasNextTask = function () {
        return this._tasks.length < this._activeTaskIndex;
    };
    FilterBase.prototype.meashurePad = function (input, target) {
        if (target === void 0) { target = input.clone(); }
        if (input === target)
            return target;
        target.copyFrom(input);
        return target;
    };
    // link up the filters correctly with the next filter
    FilterBase.prototype.setRenderState = function (source, mainTarget, sourceRect, destRect, filterManager) {
        this._activeTaskIndex = -1;
        this._tasks[0].inputRect = sourceRect;
        this._tasks[0].source = source;
        this._tasks[this._tasks.length - 1].destRect = destRect;
        this._tasks[this._tasks.length - 1].target = mainTarget;
    };
    FilterBase.prototype.dispose = function () {
        for (var _i = 0, _a = this._tasks; _i < _a.length; _i++) {
            var task = _a[_i];
            task.dispose();
        }
        this._tasks.length = 0;
    };
    FilterBase.prototype.update = function (_stage, _projection) {
    };
    FilterBase.prototype.clear = function (_manager) {
        for (var _i = 0, _a = this._temp; _i < _a.length; _i++) {
            var image = _a[_i];
            _manager.pushTemp(image);
        }
        this._temp.length = 0;
        this._activeTaskIndex = -1;
        this.imageScale = 1;
    };
    return FilterBase;
}());
export { FilterBase };
